export default "__VITE_ASSET__DwYflQs5__"